import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18617a14"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "summary-wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Order Summary:", -1))
const _hoisted_3 = { class: "details" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "SUB TOTAL"),
  /*#__PURE__*/_createElementVNode("span", { class: "annotation" }, " (+ GST)")
], -1))
const _hoisted_5 = { class: "buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", null, "$" + _toDisplayString(_ctx.totalToDisplay) + " AUD", 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_Button, {
        class: "checkout-button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'checkout' }))),
        label: "CHECKOUT"
      }),
      _createVNode(_component_Button, {
        class: "shopping-button",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({ name: 'home' }))),
        label: "CONTINUE SHOPPING"
      })
    ])
  ]))
}